module.exports = __webpack_public_path__ + "static/paycheck-c552f6c79f2e07a368a84a996b6e659c.png";